import type { CSSProperties, PropsWithChildren } from 'react';

import { cx } from '../../utils/cx';

import styles from './thumbnail.module.css';

export type ThumbnailSize =
  | 'm'
  | 'l'
  | 'xl'
  | '2xl'
  | '3xl'
  | '4xl'
  | '7xl'
  | '12xl'
  | 'cover'
  | 'fill';

export type ThumbnailProps = PropsWithChildren<{
  className?: string;
  size?: ThumbnailSize;
  url?: string;
  alt?: string;
}>;

export function Thumbnail({
  className,
  size = 'm',
  url,
  alt,
  children,
}: ThumbnailProps) {
  const a11yProps = alt
    ? { role: 'img', 'aria-label': alt }
    : { role: 'presentation' };

  let style: CSSProperties | undefined;
  if (url) {
    style = { backgroundImage: `url(${url})` };
  }

  return (
    <span
      {...a11yProps}
      className={cx([
        className,
        styles.thumbnail,
        styles[`size_${size}`],
        { [styles.thumbnail_with_image]: Boolean(url) },
      ])}
      style={style}
    >
      {children}
    </span>
  );
}
